import { DateHelpers } from "../../helpers/date-helpers";
import { ObjectHelpers } from "../../helpers/object-helpers";

export class DrawEarningNotificationDataModel {
    public earningDate = new Date();
    public pastEarningsDateDecimal = 0;
    public xValue = 0;

    constructor(data?: any) {
        if (data) {
            ObjectHelpers.setProperties(data, this, true);
        }
    }

    public getTooltip(): string {
        const pastEarningsDateStr = DateHelpers.format('dd-mm-yyyy', this.earningDate);
        
        let marketStatus = "During Market";
        if (this.pastEarningsDateDecimal == -25) {
            marketStatus = "Post-Market";
        }
        else if (this.pastEarningsDateDecimal == -75) {
            marketStatus = "Pre-Market";
        }

        const tooltip = `Earnings - ${pastEarningsDateStr} ${marketStatus} Hours.`;
        return tooltip;
    }
}